<script>
import moment from 'moment/moment';

/* MIXINS */
import permissionsMixin from '@mixins/permissionsMixin';
import sidebarMixin from '@mixins/sidebarMixin';
import prestationTypesConst from '@mixins/const/prestationTypesConst';
import missionMixin from '@mixins/missionMixin';

export default {
  components: {},
  mixins: [permissionsMixin, sidebarMixin, prestationTypesConst, missionMixin],
  props: {
    prestation: {
      type: Object,
      required: true,
    },
    firstDate: {
      required: true,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  computed: {
    typeCss() {
      if (
        this.prestation.status === 'TODO' ||
        this.prestation.status === 'DOING' ||
        this.prestation.status === 'ACCEPTED'
      )
        return 'bg-green-pale';
      if (this.prestation.status === 'COMPLETED') return 'bg-green';
      if (this.prestation.status === 'CANCELED') return 'bg-red';
      if (this.prestation.status === 'PROPOSED') return 'bg-tertiary-300';
      if (this.prestation.status === 'TO_PLAN') return 'bg-tertiary';

      return '';
    },
    textCss() {
      if (
        this.prestation.status === 'TODO' ||
        this.prestation.status === 'DOING' ||
        this.prestation.status === 'ACCEPTED'
      )
        return 'text-white';
      if (this.prestation.status === 'COMPLETED') return 'text-white';
      if (
        this.prestation.status === 'CANCELED' ||
        this.prestation.status === 'PROPOSED' ||
        this.prestation.status === 'TO_PLAN'
      )
        return 'text-white';
      return '';
    },
    title() {
      return this.displayForPrestationTypesConst(this.prestation.type);
    },
    subTitle() {
      if (this.prestation.accommodationName) return this.prestation.accommodationName;
      return this.displayForPersonnelTypeConst(this.prestation.assignedStaff);
    },
    styleReservation() {
      let colStart = moment(this.prestation.dateStart).diff(moment(this.firstDate), 'days');
      return 'grid-column : ' + (colStart + 1) + ' / ' + (colStart + 2);
    },
    hourDisplay() {
      let start = moment(this.prestation.dateStart);
      let end = moment(this.prestation.dateEnd);
      return start.format('HH:mm') + ' - ' + end.format('HH:mm');
    },
  },
};
</script>

<template>
  <component
    :is="this.hasAccessToMission ? 'router-link' : 'div'"
    :to="{name: 'mission-order-detail', params: {missionOrderId: this.prestation.id}}"
    class="flex flex-col items-center p-2 gap-1 overflow-hidden rounded-xl mx-2"
    :class="[this.typeCss, this.hasAccessToMission ? 'cursor-pointer' : '']"
    v-tooltip.bottom="this.prestation.addressDisplay"
    :style="this.styleReservation">
    <span
      class="font-medium flex items-center gap-1 flex-1 text-base w-11/12 justify-center break-words text-ellipsis text-center"
      :class="this.textCss">
      <i class="ga-icon ga-aspirateur text-2xl" v-if="this.isTypeCleaning(this.prestation.type)" />
      <i class="ga-icon ga-user_delete text-2xl" v-if="this.isTypeCheckout(this.prestation.type)" />
      <i class="ga-icon ga-user_edit text-2xl" v-if="this.isTypeCheckin(this.prestation.type)" />
      <i class="ga-icon ga-user_out text-2xl" v-if="this.isTypeMaintenanceOrRunning(this.prestation.type)" />
      <i class="ga-icon ga-user_checked text-2xl" v-if="this.isTypeQualityControl(this.prestation.type)" />

      {{ this.title }}</span
    >
    <span
      class="font-normal flex-1 text-sm overflow-hidden w-11/12 whitespace-nowrap text-ellipsis text-center"
      :class="this.textCss"
      >{{ this.subTitle }}</span
    >
    <span
      class="font-normal flex-1 text-sm overflow-hidden whitespace-nowrap text-ellipsis text-center"
      :class="this.textCss"
      >{{ this.hourDisplay }}</span
    >
  </component>
</template>
